import { getDadosBaseDB } from "@/db/base";
import axios from "axios";

const getDefaultState = () => {
  return {
    filiais: [],
    vendedores: [],       
  };
};

const baseStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setFiliais(state, filiais) {
      state.filiais = filiais;
    },
    setVendedores(state,value){
      state.vendedores = value
    }
  },
  actions: {
    async getFiliais(context) {
      context.commit("setFiliais", []);
      if (navigator.onLine) {
        await axios.get("/nutricao-animal/base/filiais").then((res) => {
          if (res.data.success) {
            context.commit("setFiliais", res.data.data);
          }
        });
      }else{        
        var listaFiliais = await getDadosBaseDB()        
        if(listaFiliais.length > 0){
          context.commit('setFiliais', listaFiliais[0].filiais)
        }        
      }
    },
    async getVendedores(context){
      context.commit("setVendedores",[])
      await axios.get("/nutricao-animal/base/vendedores").then((res) => {
        if(res.data.success){
          context.commit("setVendedores",res.data.data)
        }
      })
    }
  },
  getters: {},
};

export default baseStore;
